import React from 'react';
import { SchoolDetailsPageLayout } from './SchoolDetailsPageLayout';

const SchoolDetailsPageContainer: React.FC = () => {
    return (
        <React.Fragment>
            <SchoolDetailsPageLayout/>
        </React.Fragment>
    );
};

export default SchoolDetailsPageContainer;